import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  flex-direction: column;\n  overflow: hidden;\n  min-width: 136px;\n  background: ",
        ";\n  border-radius: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  background: transparent;\n  padding: 8px 16px;\n  color: ",
        ";\n  width: 100%;\n  height: 45px;\n  font-size: 14px;\n  text-align: left;\n\n  &:hover {\n    background-color: ",
        ";\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import { Box, Flex } from "../Box";
export var InlineMenuContainer = styled(Box).withConfig({
    componentId: "sc-e35eb6f0-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.tooltip;
});
export var SubMenuContainer = styled(Flex).withConfig({
    componentId: "sc-e35eb6f0-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.cardHeaderBg;
});
export var ClickableElementContainer = styled.div.withConfig({
    componentId: "sc-e35eb6f0-2"
})(_templateObject2());
export var SubMenuItem = styled.button.withConfig({
    componentId: "sc-e35eb6f0-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});
